<template>
  <!-- Conversion Rates Section Begins -->
  <div class="conversion-rates" data-track="Review Analytics Conversions Rate Tab view">
    <!-- Various Filters Begins -->
    <div class="columns conversion-filters">
      <span class="column is-one-third filters-heading">Conversion rate over time</span>
      <!-- Filters For Landing Page Begins -->
      <span class="column is-2 landing-page-filters">
        <label class="checkbox is-size-6 label-filters">
          <input
            checked
            type="checkbox"
            :value="1"
            v-model="filters.landingPage"
            @change="handleFilters()"
          >
          <span class="checkmark landing-page"></span>
        </label>
        <span class="checkbox-label">Landing page</span>
      </span> <!-- Filters For Landing Page Ends -->
      <!-- Filters For In-mail Begins -->
      <span class="column is-2 in-mail-filters">
        <label class="checkbox is-size-6 label-filters">
          <input
            checked
            type="checkbox"
            :value="1"
            v-model="filters.inMail"
            @change="handleFilters()"
          >
          <span class="checkmark in-mail"></span>
        </label>
        <span class="checkbox-label">In-mail</span>
      </span> <!-- Filters For In-mail Ends -->
      <!-- Filters For SMS Begins -->
      <span class="column is-2 sms-filters">
        <label class="checkbox is-size-6 label-filters">
          <input
            checked
            type="checkbox"
            :value="1"
            v-model="filters.sms"
            @change="handleFilters()"
          >
          <span class="checkmark sms"></span>
        </label>
        <span class="checkbox-label">SMS</span>
      </span> <!-- Filters For SMS Ends -->
    </div> <!-- Various Filters Ends -->
    <!-- Graph Section Begins -->
    <div class="vue-line-chart has-spinner">
      <img class="has-spinner__spinner" src="/static/img/loaders/spinner.svg" v-if="isLoading">
      <vue-chart
        chart-type="LineChart"
        :rows="analyticsData"
        :columns="graphColumns"
        :options="reviewInvitesAnalyticsOptions"
      >
      </vue-chart>
    </div> <!-- Graph Section Ends -->
  </div> <!-- Conversion Rates Section Ends -->
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc */
  import misc from '@/mixins/graphs.js'
  import { mapState, mapActions } from 'vuex'
  import {FETCH_REVIEW_INVITE_CONVERSION_ANALYTICS_GRAPHS} from '@/store/action.types'
  export default {
    name: 'ConversionRateTab',
    mixins: [misc],
    data () {
      return {
        isLoading: false,
        loadingIndex: 0,
        requestCount: 0,
        filters: {sms: 1, inMail: 1, landingPage: 1},
        graphColumns: [
          {type: 'string', label: 'Date'},
          {type: 'number', label: 'Landing page'}, {label: '', role: 'style', type: 'string'},
          {type: 'number', label: 'In mail'}, {label: '', role: 'style', type: 'string'},
          {type: 'number', label: 'SMS'}, {label: '', role: 'style', type: 'string'}
        ]
      }
    },
    computed: {
      ...mapState({
        analyticsData: state => state.analytics.reviewInvites.graphs.conversions
      }),
      /**
       * Creating a payload for showing graph
       * @return {object}
       */
      reviewInvitesAnalyticsOptions () {
        return Object.assign(this.reviewAnalyticsOptions, {
          height: 386,
          isStacked: true,  // Multiple columns in single point
          animation: {easing: 'out', startup: true, duration: 800},
          chartArea: {top: '2%', left: '4%', width: '94.5%', height: '80%', bottom: '5%'},
          series: {
            0: {type: 'line', color: '#1d7299'}
          }
        })
      },
      /**
       * Creating a payload for HTTP request
       * @return {object}
       */
      payload () {
        return Object.assign(this.filters, this.$parent.payload)
      }
    },
    created () {
      /** Listening to DateDropdown Change */
      this.$parent.$on('onDateChangeForConversions', data => {
        this.handleFilters()
      })
      this.handleFilters()
    },
    beforeDestroy () {
      this.$parent.$off('onDateChangeForConversions')
    },
    methods: {
      ...mapActions({
        'fetchReviewInvitesAnalyticsGraphs': `analytics/${FETCH_REVIEW_INVITE_CONVERSION_ANALYTICS_GRAPHS}`
      }),
      /**
       * Handle all the filters
       * @return {void}
       */
      handleFilters () {
        this.loadingIndex++
        this.isLoading = true
        this.fetchReviewInvitesAnalyticsGraphs(this.payload)
        .then(() => {
          this.isLoading = true
          this.requestCount++
        })
        .then(() => {
          if (this.loadingIndex === this.requestCount) {
            this.isLoading = false
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

  /* Local CSS Begins */
  .conversion-filters {
    margin-bottom: 0;
  }
  .conversion-rates {
    height: 450px;
    margin-top: 2%;
  }
  .filters-heading {
    width: 17%;
    color: #58595b;
    font-size: 11px;
    font-weight: bold;
  }
  .checkbox-label {
    color: #58595b;
    font-size: 11px;
    margin-left: 4px;
    vertical-align: top;
  }
  .landing-page-filters {
    width: 9.8%;
    padding: 12px 0;
    letter-spacing: 0.1px;
  }
  .in-mail-filters {
    width: 6.8%;
    padding: 12px 0 12px 6px;
    letter-spacing: 0.1px;
  }
  .sms-filters {
    padding-left: 8px;
    letter-spacing: 0.1px;
  }
  .label-filters {
    bottom: 1px;
  }
  .label-filters input {
    width: 17px;
    height: 17px;
    border: solid 1px #707070;
  }
  .label-filters .chart-dropdown-rating ul.width-180 {
    text-align: right !important;
  }
  is-block {
    display: block;
  }
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    width: 17px;
    height: 16px;
    background-color: #fff;
    border: solid 1px #707070;
  }
  /* On mouse-over, add a grey background color */
  .label-filters:hover input ~ .checkmark {
    background-color: #fff;
  }
  /* When the checkbox is checked, add a colored background */
  .label-filters input:checked ~ .landing-page {
    border: none;
    background-color: #c0b5f1;
  }
  .label-filters input:checked ~ .in-mail {
    border: none;
    background-color: #6a4ee4;
  }
  .label-filters input:checked ~ .sms {
    border: none;
    background-color: color('blue');
  }
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    display: none;
    position: absolute;
  }
  /* Show the checkmark when checked */
  .label-filters input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the checkmark/indicator */
  .label-filters .checkmark:after {
    left: 7px;
    top: 2px;
    width: 5px;
    height: 9px;
    border: solid white;
    transform: rotate(45deg);
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
  }
  /* Media Queries begins */
  /* Media Query For Tablet */
  @media screen and (min-width: 767px) {
    .filters-heading {
      width: 21%;
    }
    .landing-page-filters, .sms-filters {
      width: 12.8%;
    }
    .in-mail-filters {
      width: 9.8%;
    }
  }
  /* Media Query For Tablet(Vertical View) */
  @media screen and (min-width: 768px) and (max-width: 1023px){
    .filters-heading {
      width: 25%;
    }
    .landing-page-filters {
      width: 15.8%;
    }
    .in-mail-filters {
      width: 10.8%;
    }
  }
  /* Media Query For Desktop and Big Screens */
  @media screen and (min-width: 1280px) {
    .filters-heading {
      width: 17%;
    }
    .landing-page-filters {
      width: 9.8%;
    }
    .in-mail-filters {
      width: 6.8%;
    }
  }
  /* Media Queries ends */
  /* Local CSS Ends */
</style>



// WEBPACK FOOTER //
// src/pages/analytics/invites/ConversionRateTab.vue